import { AppState } from 'src/app/store'

export const footprintTypeSelectors = (state: AppState) => state.footprint.footPrintTypes
export const footprintVsCompensationSelector = (state: AppState) => state.footprint.footPrintVsCompensation
export const footPrintHistorySelectors = (state: AppState) => state.footprint.footPrintHistory
export const myFootprintSelector = (state: AppState) => state.footprint.myFootprint
export const createFootprintSelector = (state: AppState) => state.footprint.createFootPrint
